export default "__VITE_ASSET__db96cb9c__"